import { observable } from "mobx";

import { MedicalDataCategory, SupportedMedicalData } from "../../../api";
import { ApiConnector } from "../../../api/api-connector";
import { fetchSupportedMedicalData } from "../../../catalogs/supported-medical-data";
import { DataAdd } from "../../../models/data-add";
import { getServerNowISO } from "../../../utils/server-time";
import { Patient } from "../patient";

export class AddOtherExams extends DataAdd {
  @observable accessor supportedVariables: SupportedMedicalData[] = [];

  constructor(api: ApiConnector, patient: Patient) {
    super(api, patient);
    this.initFields = [
      "measurement_datetime",
      "measurement_type",
      "measurement_unit",
    ];
    this.desc = "Other (ECG) exams";
    this.defaultDateTimeName = "Now";
    this.defaultDateTimeFields = ["measurement_datetime"];
    this.bodyField = "medical_data";
    this.endpoint = "medicaldata/bulk";
    this.reloadToTab = "exams";
    this.requiredFields = [
      "measurement_datetime",
      "measurement_type",
      "measurement_value",
    ];
  }

  async initEmpty() {
    this.defaultDateTime = getServerNowISO();
    const supportedMedData = await fetchSupportedMedicalData();
    this.supportedVariables = supportedMedData.filter(
      (data) =>
        data.data_category === MedicalDataCategory.exams_basic ||
        data.data_category === MedicalDataCategory.exams_final,
    );
    const empty = [];
    for (const variable of this.supportedVariables) {
      const temp = {
        measurement_datetime: this.defaultDateTime,
        measurement_type: variable.data_name,
        measurement_unit: variable.primary_unit,
      };
      empty.push(temp);
    }
    this.addingList = empty;
  }
}
